export default __webpack_public_path__ + "static/media/instructor 2.f3daaa48.jpg";